export default __webpack_public_path__ + "b54ebb31fbcf75208b8310818a5c6290.svg";